// extracted by mini-css-extract-plugin
export var navLink = "navLink-module--navLink--2tDrq";